const serialize = (item: boolean): string => (item ? 'true' : 'false');

const deserialize = (str: string): boolean => str === 'true';

export default { deserialize, serialize };
